module.exports = __webpack_public_path__ + "4b24e98734ac6d07305f3e6f261224df.jpg";